import { SpineEntry, SpineMeta } from "./types";

export const state = {
  currentActiveId: null as string | null,
  spineEntries: [] as SpineEntry[],
  spineMetaById: {} as Record<string, SpineMeta>,
  currentIframe: null as HTMLIFrameElement | null,
  spaceKeyListenerAttached: false,
  pmaEnabled: true,
  currentPlayerProxy: null as { play: () => void; pause: () => void; paused: boolean } | null
};
